"use strict";
exports.__esModule = true;
exports.TOGGLE_VIEW_CREDENTIALS_MODAL = exports.TOGGLE_FETCH_ERROR = exports.TOGGLE_LOADER = exports.UPDATE_SELECTED_LANGUAGE = exports.UPDATE_DEPLOYMENT_DATA = exports.DATA_SAVED = exports.UPDATE_SDK_DATA = exports.SET_SDK_EDITED_FALSE = exports.SET_DEPLOYMENT_EDITED_FALSE = exports.SET_SDK_CONFIG = exports.SET_DEPLOYMENTS = exports.SET_ACTIVE_DEPLOYMENT_OPTION = exports.SET_ACTIVE_TAB = void 0;
exports.SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
exports.SET_ACTIVE_DEPLOYMENT_OPTION = 'SET_ACTIVE_DEPLOYMENT_OPTION';
exports.SET_DEPLOYMENTS = 'SET_DEPLOYMENTS';
exports.SET_SDK_CONFIG = 'SET_SDK_CONFIG';
exports.SET_DEPLOYMENT_EDITED_FALSE = 'SET_DEPLOYMENT_EDITED_FALSE';
exports.SET_SDK_EDITED_FALSE = 'SET_SDK_EDITED_FALSE';
exports.UPDATE_SDK_DATA = 'UPDATE_SDK_DATA';
exports.DATA_SAVED = 'DATA_SAVED';
exports.UPDATE_DEPLOYMENT_DATA = 'UPDATE_DEPLOYMENT_DATA';
exports.UPDATE_SELECTED_LANGUAGE = 'UPDATE_SELECTED_LANGUAGE';
exports.TOGGLE_LOADER = 'TOGGLE_LOADER';
exports.TOGGLE_FETCH_ERROR = 'TOGGLE_FETCH_ERROR';
exports.TOGGLE_VIEW_CREDENTIALS_MODAL = 'TOGGLE_VIEW_CREDENTIALS_MODAL';
